import React, { useContext, useEffect, useState } from 'react'
import ReactModal from 'react-modal';
import { Context } from 'Context/Context';
import ProfesssionalDetailsPopUp from './ProfesssionalDetailsPopUp';
import { casesStatusUpdateApi, raiseNotificationApi } from 'Constants';
import { getCaseType } from 'Utils';
import PreApproveAttorneysTable from 'Components/Client/Cases/CaseDetails/PreApproveAttorneysTable';
import useIsMobile from 'Hooks/useIsMobile';


function PreapproveProfessionalsModal({uploadNew, onClose, profList,caseDetails, submit, approveProfessional}) {
  const isMobile = useIsMobile();
  
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 50
        },
        content: {
            zIndex: 50,
            width: isMobile ? '90%' : '-webkit-calc(100% - 200px)',
            height: 'auto',
            padding: isMobile ? '5px' : '20px',
            maxHeight: '-webkit-calc(100% - 50px)',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        }
      }}
    >   
     
        <PreApproveAttorneysTable
        profList={profList}
        caseDetails={caseDetails}
        approveProfessional={approveProfessional}
        title = {
            <div className='flex flex-col items-center justify-left font-bold  w-full '>
            <div className='text-sm lg:text-base text-gray-600 mb-6'>Attorneys Available for your {getCaseType(caseDetails?.caseType)} case</div>
            {/* <span className='text-md font-semibold text-gray-800 italic'>
            Even before the professionals start requesting for the cases, you can preapprove Attorneys of your choice to work on your case. 

            </span>  */}
        </div>
        }

        />
    </ReactModal>
  )
}

export default PreapproveProfessionalsModal;
